import actionTypes from '../actions/types';

export const INITIAL_STATE = {
  locale: 'en',
  localeData: {},
};

const handleUpdateLocaleData = (state, { locale, data }) => {
  const localeData = {
    ...state.localeData,
    [locale]: { ...data },
  };
  return { ...state, localeData, locale };
};

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_LOCALE_DATA:
      return handleUpdateLocaleData(state, action);
    default:
      return state;
  }
};
